<template>
    <div class="bind-kin">
      <!-- 标题 -->
      <h1>绑定亲属</h1>
      <!-- 表单输入 -->
      <div class="input-item">
        <label for="phone">手机号</label>
        <input id="phone" v-model="formData.phone" placeholder="请输入手机号" />
      </div>
      <div class="input-item">
        <label for="name">姓名</label>
        <input id="name" v-model="formData.name" placeholder="请输入姓名" />
      </div>
      <!-- 操作按钮 -->
      <div class="action-btns">
        <button @click="handleBack">返回</button>
        <button @click="handleConfirm">确认</button>
      </div>
      <!-- 操作说明 -->
      <div class="operation-tips">
        <p>操作说明：</p><br/>
        <ol>
          <li>输入亲属手机号和姓名</li>
          <li>亲属使用上方输入手机号登录</li>
          <li>预约信息将同步到亲属的账号，可同时视频</li>
          <li>登录成功后点击“我的预约”--"亲属"，可查看预约订单</li>
        </ol>
      </div>
    </div>
  </template>
  
  <script>
  import { bindKin } from '@/api/orderBindApi'
  export default {
    data() {
      return {
        // 表单输入数据
        formData: {
          phone: '',
          name: ''
        }
      };
    },
    methods: {
      handleBack() {
        this.$router.replace({
          path: '/orderlist'
        })
      },
     async handleConfirm() {
      if (!this.formData.phone || !this.formData.name) {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: '请填写完整信息'
        }).show()
        return;
      } 
        const orderId = this.$route.query.orderId
        const params = {
          phone: this.formData.phone,
          name: this.formData.name,
          orderId: orderId
        } 
        await bindKin(params).then(res => {
          if (res.code === '9000200') {
            this.$createDialog({
              type: 'alert',
              title: '绑定成功',
              content: res.message
            }).show()
          } else {
            this.$createDialog({
              type: 'alert',
              title: '绑定失败',
              content: res.message
            }).show()
          }
        })
      }
    }
  };
  </script>
<style lang="css" scoped>
.bind-kin {
  color: #fff;
  padding: 20px;
  font-family: 'Arial', sans-serif;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.input-item {
  display: flex;
  margin-bottom: 12px;
}

.input-item label {
  margin: 0 10px;
  width: 60px;
  background-color: #fff229;
  color: #222;
  padding: 6px 10px;
  border-radius: 4px;
  margin-right: 8px;
  text-align: center;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-item input {
  margin: 0 10px;
  flex: 1;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-left: none;
  border-radius: 4px;
  font-size: 14px;
}

.input-item input:focus {
  outline: none;
  border-color: #fff229;
}

.action-btns {
  text-align: center;
  margin-top: 20px;
}

.action-btns button {
  margin: 0 10px;
  padding: 8px 16px;
  background-color: #fff229;
  color: #222;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.action-btns button:hover {
  background-color: #f0f0f0;
}

.operation-tips {
  margin-top: 20px;
  font-size: 14px;
}

.operation-tips ol {
  list-style-type: decimal;
  margin-left: 20px;
  line-height: 24PX;
}
.operation-tips ol li {
  margin-bottom: 8px;
}
</style>
  